import { Controller } from "@hotwired/stimulus"
import { post, destroy } from "@rails/request.js"

export default class extends Controller {
  static values = {
    url: String,
    name: String
  }

  async save(event) {
    const columns = event.detail.columns
    columns.forEach(column => {
      const columnElement = this.element.querySelector(`cocoon-column[name=${column.name}]`)
      column.width = parseInt(columnElement.parentElement.style.minWidth, 10)
    })

    post(this.urlValue, {
      body: {
        name: this.nameValue,
        columns: columns
      }
    })
  }

  reset() {
    destroy(this.urlValue, {
      body: {
        name: this.nameValue
      },
      responseKind: "turbo-stream"
    })
  }
}
